import { useEffect } from "react";
import InputForm from "../components/inputform";
import { Button, Row, Col } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import {
  selectDeviceType,
  userCheckInu,
  userCheckWal,
  getLastDeviceData,
  selectDeviceInfoData,
  pushDeviceData,
  addDeviceData,
  deleteDeviceData,
} from "../../store/deviceData/deviceDataSlice";

export default function MainLayout() {
  const dispatch = useAppDispatch();
  const deviceType = useAppSelector(selectDeviceType);
  const deviceInfoData = useAppSelector(selectDeviceInfoData);
  useEffect(() => {
    dispatch(getLastDeviceData({deviceType,prdId:'0'}));
  }, [deviceType]);

  const confirmAction = (message: string, action: () => void) => {
    if (window.confirm(message)) {
      action();
    }
  };

  const pushData = () => {
    confirmAction(
      `시리얼넘버 ${deviceType} ${deviceInfoData?.prd_id} 수정하시겠습니까?`,
      () => dispatch(pushDeviceData({ deviceType, deviceInfoData })).then(()=>{
        dispatch(getLastDeviceData({deviceType,prdId:'0'}));
      })
    );
    
  };
  const addData = () => {
    confirmAction(
        `시리얼넘버 ${deviceType} ${deviceInfoData?.prd_id} 새로 만드시겠습니까?`,
        () => dispatch(addDeviceData({ deviceType, deviceInfoData })).then(()=>{
          dispatch(getLastDeviceData({deviceType,prdId:'0'}));
        })
      );
      
  };
  const removeData = () => {
    confirmAction(
        `시리얼넘버 ${deviceType} ${deviceInfoData?.prd_id} 정말 삭제하시겠습니까?`,
        () => dispatch(deleteDeviceData({ deviceType, deviceInfoData })).then(()=>{
          dispatch(getLastDeviceData({deviceType,prdId:'0'}));
        })
      );
      
  };
  return (
    <>
      <button onClick={() => dispatch(getLastDeviceData({deviceType,prdId:'0'}))}>
        새로고침
      </button>
      <span>&nbsp;&nbsp;&nbsp;</span>
      <input
        type="radio"
        id="inu"
        checked={deviceType === "inu"}
        onChange={() => dispatch(userCheckInu())}
      />
      <label htmlFor="inu">inu</label>
      <input
        type="radio"
        id="wal"
        checked={deviceType === "wal"}
        onChange={() => dispatch(userCheckWal())}
      />
      <label htmlFor="wal">wal</label>

      {deviceInfoData && <InputForm />}
      <Row>
        <Col>
          <Button onClick={() => pushData()}>수정</Button>
        </Col>
        <Col>
          <Button onClick={() => addData()}>새로추가</Button>
        </Col>
        <Col>
          <Button onClick={() => removeData()}>삭제</Button>
        </Col>
      </Row>
    </>
  );
}
